import script from "./tab-card.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-card.vue?vue&type=script&setup=true&lang=js"

import "./tab-card.vue?vue&type=style&index=0&id=44374710&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44374710"]])

export default __exports__